module.exports = __webpack_public_path__ + "img/id_step_bg@2x.708b7f08.png";